(function documentFindControllerDefinition() {
    'use strict';

    angular.module('Document')
        .controller('DocumentFindController', [
            '$q', '$filter', '$scope', '$state', 'errorsExtend', 'processCustomerService', 'configViewService', 'organizationalUnitService', 'authExtend', '$translate', 'storageService', 'fileWorkflowService', 'fileDownloader', 'exportProcessService',
            function documentFindController($q, $filter, $scope, $state, errors, processCustomerService, configViewService, organizationalUnitService, auth, $translate, storageService, fileWorkflowService, fileDownloader, exportProcessService) {

                $translate(['PaginationNext', 'PaginationPrev', 'PaginationFirstFem', 'PaginationLastFem'])
                    .then(function (translated) {
                        $scope.paginatorTranslations = {
                            nextText: translated.PaginationNext,
                            previousText: translated.PaginationPrev,
                            lastText: translated.PaginationLastFem,
                            firstText: translated.PaginationFirstFem
                        };
                    });

                $scope.accordionState = {
                    isOpen: true
                };

                if ($state.params.isSignPending) {
                    $scope.legend = { type: 'warning', message: 'PayCheckSignPending' }
                }

                $scope.createFilters = function () {
                    var idOu = $scope.find.organizationalUnit ? $scope.find.organizationalUnit.id : undefined;

                    var filters = {
                        name: $scope.find.name,
                        processTypeId: $scope.find.processType.id,
                        organizationalUnitId: idOu,
                        processStatesIds: [],
                        metadatas: [],
                        dateFrom: $scope.find.dateFrom,
                        dateTo: $scope.find.dateTo,
                        itemPerPage: $scope.data.itemPerPage,
                        page: $scope.data.currentPage
                    };

                    $scope.find.showNoData = false;

                    $scope.find.processType.metadatas.forEach(function (meta) {
                        filters.metadatas.push(meta);
                    });

                    if ($scope.find.selectedStates && $scope.find.selectedStates.length > 0) {
                        $scope.find.selectedStates.forEach(function (state) {
                            filters.processStatesIds = filters.processStatesIds.concat(state.ids);
                        });
                    } else {
                        $scope.find.processType.states.forEach(function (state) {
                            filters.processStatesIds = filters.processStatesIds.concat(state.ids);
                        });
                    }

                    return filters;
                }

                $scope.executeFind = function () {
                    var filters = $scope.createFilters();

                    return processCustomerService.advancedGet(filters).then(function (result) {
                        $scope.documents = [];
                        $scope.data.totalItems = result.count;
                        $scope.data.from = 1 + ($scope.data.itemPerPage * ($scope.data.currentPage - 1));
                        result.values.forEach(function (value) {
                            var r = value;
                            r.metadatas = [];

                            $scope.find.processType.headers.forEach(function (header) {
                                var metadataFound = $filter('filter')(value.metadataValues, { systemName: header.systemName }, true);
                                if (metadataFound && metadataFound.length != 0) {
                                    var metadataDescription = metadataFound[0].value;
                                    filters.metadatas.forEach(function (value) {
                                        var metadataOptionFound = $filter('filter')(value.metadataOptions, { value: metadataFound[0].value }, true);
                                        if (metadataOptionFound && metadataOptionFound.length != 0) {
                                            metadataDescription = metadataOptionFound[0].description;
                                        }
                                    });

                                    r.metadatas.push({ value: metadataDescription, type: metadataFound[0].type, mask: header.mask });
                                } else {
                                    r.metadatas.push({ value: null, type: null, mask: null });
                                }
                            });

                            $scope.documents.push(r);
                        });

                        if ($scope.documents.length == 0) {
                            $scope.find.showNoData = true;
                        }

                        if ($scope.documents.length > 0) {
                            $scope.accordionState.isOpen = false;
                            $scope.find.showResult = true;
                            $scope.fillAccordion();
                        }
                    }, function (error) {
                        errors.showError(error);
                    });
                };

                $scope.findAction = function () {
                    if (!$scope.documentFind.$valid) {
                        $scope.documentFind.$setSubmitted();
                        errors.showError('VerifyFormData');
                        return false;
                    }

                    storageService.setDocumentFilter($scope.find);

                    return $scope.executeFind();
                };

                $scope.view = function (process) {
                    $state.go('document-detail', { id: process.id });
                };

                $scope.loadPreFilters = function () {
                    if (!$scope.find.processType) {
                        var found = $filter('filter')($scope.processTypes, { preSelected: true }, true);
                        $scope.find.processType = angular.copy(found[0] || $scope.processTypes[0]);
                    }

                    $scope.find.selectedStates = $filter('filter')($scope.find.processType.states, { preSelected: true }, true);
                };

                $scope.cleanFilters = function () {
                    $scope.accordionState.isOpen = true;

                    storageService.clearDocumentFilter();

                    $scope.find = storageService.getDocumentFilter();
                    $scope.documents = [];

                    $scope.data = {
                        currentPage: 1,
                        totalItems: 0,
                        itemPerPage: 15,
                        from: 0
                    }

                    $scope.loadPreFilters();

                    angular.forEach($scope.processTypes, function (item) {
                        if (item.id === $scope.find.processType.id) {
                            $scope.find.processType.metadatas = angular.copy(item.metadatas);
                        }
                    });
                };

                $scope.fillAccordion = function () {
                    $scope.documents.forEach(function (document) {
                        var accordionIsOpen = false;
                        Object.defineProperty(document, "accordionIsOpen", {
                            get: function () { return accordionIsOpen; },
                            set: function (newValue) {
                                if (event.target.id !== "options" && !(event.target.offsetParent !== null && event.target.offsetParent.id === "options")) {
                                    if (event.target.offsetParent !== null && event.target.offsetParent.offsetParent.id === "p") {
                                        accordionIsOpen = newValue;
                                    }
                                }
                            }
                        });
                    });
                };

                $scope.selectProcessType = function (processType) {
                    $scope.find.processType = angular.copy(processType);
                    $scope.documents = [];
                    $scope.find.showResult = false;
                    $scope.data = {
                        currentPage: 1,
                        totalItems: 0,
                        itemPerPage: 15,
                        from: 0
                    }

                    $scope.actions = {
                        delete: false,
                        edit: false
                    };

                    $scope.loadPreFilters();
                };

                $scope.loadMetadata = function (item) {
                    var processType = {
                        name: item.name,
                        id: item.processTypeId,
                        preSelected: item.preSelected,
                        states: item.groupStates,
                        metadatas: [],
                        headers: []
                    };

                    item.metadatas.forEach(function (metadata) {
                        if (metadata.resultCriteria) {
                            processType.headers.push({ label: metadata.resultCriteria.name, systemName: metadata.systemName, order: metadata.resultCriteria.order, mask: metadata.resultCriteria.mask });
                        }

                        if (metadata.searchCriteria) {
                            processType.metadatas.push({
                                idObject: item.name.replace(/ /g, '_') + metadata.systemName,
                                metadataId: metadata.metadataId,
                                metadataValueFrom: undefined,
                                metadataValueTo: undefined,
                                metadataSearchTypeFrom: undefined,
                                metadataSearchTypeTo: undefined,
                                metadataType: metadata.metadataType != null ? metadata.metadataType.toLowerCase() : undefined,
                                metadataSystemName: metadata.systemName,
                                metadataLabel: metadata.searchCriteria.name,
                                metadataReadOnly: !metadata.searchCriteria.isEditable,
                                metadataEnabled: true,
                                metadataOptions: metadata.metadataOptionValues,
                                maskOptions: metadata.metadataMaskOption,
                                order: metadata.searchCriteria.order
                            });
                        }
                    });

                    processType.metadatas.sort(function (a, b) {
                        return a.order - b.order;
                    });

                    processType.headers.sort(function (a, b) {
                        return a.order - b.order;
                    })

                    processType.states.sort(function (a, b) {
                        return a.order - b.order;
                    });

                    $scope.processTypes.push(processType);
                };

                $scope.loadViewOptions = function () {
                    var defered = $q.defer();
                    var promise = defered.promise;

                    if ($scope.processTypes && $scope.processTypes.length > 0) {
                        defered.resolve();
                    } else {
                        $q.all([configViewService.getById("CPPDocument"), organizationalUnitService.getRootOf(auth.getOrganizationId())]).then(function (result) {
                            var configView = result[0];
                            var rootOu = result[1].filter(function (item) { return item.isRoot })[0];

                            if (configView.processTypes && configView.processTypes.length > 0) {
                                $scope.processTypes = [];

                                angular.forEach(configView.processTypes, function (item) {
                                    if (item.organizationalUnitId == rootOu.id) {
                                        $scope.loadMetadata(item);
                                    }
                                });

                                if ($scope.processTypes.length === 0) {
                                    defered.reject('DocumentNoCustomProcessType');
                                }
                            }

                            defered.resolve();
                        }, function (error) {
                            errors.showError(error);
                            defered.reject();
                        });
                    }

                    return promise;
                };

                $scope.downloadAllFiles = function () {
                    var files = [];

                    $scope.documents.forEach(function (document) {
                        document.files.forEach(function (file) {
                            files.push({ id: file.id, name: file.name });
                        });
                    });

                    return fileWorkflowService.downloadFilesIntoZip(files).then(function (result) {
                        var success = fileDownloader.saveAs(result.value, $translate.instant('DocumentAllFiles') + '.zip');

                        if (!success) {
                            errors.showError('Api failed');
                        }
                    }, function (error) {
                        if (error.status === 204) {
                            errors.showWarning('The document has no files');
                        } else {
                            errors.showError('Api failed');
                        }
                    });
                };

                $scope.downloadFile = function (document) {
                    var file = document.files[0];

                    return fileWorkflowService.downloadFile(file.id).then(function (result) {
                        var success = fileDownloader.saveAs(result, file.name);

                        if (!success) {
                            errors.showError('Api failed');
                        }
                    }, function (error) {
                        if (error.status === 204) {
                            errors.showWarning('The document has no files');
                        } else {
                            errors.showError('Api failed');
                        }
                    });
                };

                $scope.exportToExcel = function () {
                    $translate(['ProcessReceptionDateView', 'ProcessState', 'User', 'ProcessName'])
                        .then(function (translated) {
                            var headers = [];

                            var filters = $scope.createFilters();

                            filters.itemPerPage = null;
                            filters.page = null;

                            headers.push({ key: "CreationDate", value: "F. Recepcion" });

                            $scope.find.processType.headers.forEach(function (header) {
                                headers.push({ key: header.systemName, value: header.label });
                            });

                            headers.push({ key: "StateAlias", value: translated.ProcessState });
                            headers.push({ key: "UserStep", value: translated.User });
                            headers.push({ key: "Name", value: translated.ProcessName });

                            return exportProcessService.exportCustomerToXLS(filters, headers, 'Recibos').then(function (result) {
                                var d = new Date();

                                var docName = "Mis Documentos";

                                var success = fileDownloader.saveAs(result.value, docName +
                                    '_' +
                                    d.getUTCFullYear() +
                                    '-' +
                                    (d.getUTCMonth() + 1) +
                                    '-' +
                                    d.getDate() +
                                    '.xlsx');

                                if (!success) {
                                    errors.showError('Api failed');
                                }

                            }, function (error) {
                                errors.showError('Api failed');
                            });
                        });
                };

                $scope.load = function () {
                    $scope.data = {
                        currentPage: 1,
                        totalItems: 0,
                        itemPerPage: 15,
                        from: 0
                    }

                    $scope.find = storageService.getDocumentFilter();

                    $q.all([$scope.loadViewOptions()]).then(function (result) {
                        $scope.loadPreFilters();
                        $scope.executeFind();
                    });
                };

                $scope.load();

            }]);
})();